export const handleError = (error) => {
  const { status, message } = error;
  switch (status) {
    case 401:
      console.log("Failed with status code 401");
      break;
    // do something when you're unauthenticated
    case 403:
      console.log("Failed with status code 403");
      break;
    // do something when you're unauthorized to access a resource
    case 500:
      console.log("Failed with status code 500");
      break;
    // do something when your server exploded
    default:
      console.log("Failed with error:", error);
    // handle normal errors with some alert or whatever
  }
  return message; // I like to get my error message back
};
